import Skeleton from '@mui/material/Skeleton'
import { range } from 'libraries/lodash'

const ROW_WIDTHS = ['w-50', 'w-40', 'w-60', 'w-33', 'w-55', 'w-40']

function SectionHeader (): JSX.Element {
  return (
    <div className='ma0 bg-precedents-blue pv4 ph4'>
      <Skeleton variant='text' classes={{ root: 'w-40 bg-white o-40', text: 'f5 fw7' }} />
    </div>
  )
}

function SubsectionHeader (): JSX.Element {
  return (
    <div className='basis-100 ma0 bg-precedents-blue-10 pv3 ph6'>
      <Skeleton variant='text' classes={{ root: 'w-30 bg-grey', text: 'f5 fw7' }} />
    </div>
  )
}

function ColumnHeader (): JSX.Element {
  return (
    <div className='flex pv3 f6 bb bb-light-bluish-grey bg-precedents-blue-10 basis-100'>
      <div className='ml6 o-40'>
        <Skeleton variant='text' classes={{ root: 'w5 bg-grey', text: 'f6' }} />
      </div>
      <div className='flex mlauto mr6 o-40'>
        <Skeleton variant='text' classes={{ root: 'w8 bg-grey', text: 'f6' }} />
      </div>
    </div>
  )
}

function DocumentRow ({ width }: { width: string }): JSX.Element {
  return (
    <li className='bb bb-light-bluish-grey ph6 pv5 flex items-center justify-between'>
      <Skeleton variant='text' classes={{ root: `${width} bg-grey`, text: 'f5' }} />
      <Skeleton variant='rectangular' classes={{ root: 'bg-grey ml4' }} width={20} height={20} />
    </li>
  )
}

export default function DocumentsAllSkeleton (): JSX.Element {
  return (
    <ul className='list-reset pa0 ma0'>
      {range(0, 3).map((_, si) => (
        <li key={si}>
          <SectionHeader />
          {range(0, 2).map((_, subI) => (
            <div key={subI} className='flex flex-wrap f6 bb bb-light-bluish-grey'>
              <SubsectionHeader />
              <ColumnHeader />
              <ol className='list-reset ma0 pa0 basis-100'>
                {range(0, 4).map((_, di) => (
                  <DocumentRow key={di} width={ROW_WIDTHS[(subI * 4 + di) % ROW_WIDTHS.length]} />
                ))}
              </ol>
            </div>
          ))}
        </li>
      ))}
    </ul>
  )
}
